export default {
  root: {
    maxWidth: '454px',
  },
};
